import React from 'react';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const TableIconBadge = ({ title, type, icon }) => {
  return (
    <SoftBadge pill bg={type} className="fs--2">
      {title}
      <FontAwesomeIcon icon={icon} className="ms-2" />
    </SoftBadge>
  );
};

TableIconBadge.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

export default TableIconBadge;
